<template>
  <div id="app">
    <v-app>
      <page-header />
      <main>
        <v-container fluid>
          <router-view />
        </v-container>
      </main>
      <page-footer />
    </v-app>
  </div>
</template>

<script>
import PageHeader from '@/components/Header.vue'
import PageFooter from '@/components/Footer.vue'

export default {
	name: 'App',
	components: {
		PageFooter,
		PageHeader
	}
}
</script>

<style>
#app {
  font-family: Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 50px;

}
*{ text-transform: none !important; }
.danger-alert {
  color: red;
}
</style>
6hnu


// WEBPACK FOOTER //
// src/App.vue